export default {
  user: (state) => state.user,
  watchList: (state) => state.watchList,
  preferences: (state) => state.preferences,
  messages: (state) => state.preferences?.messages,
  watchListOnly: (state) => state.watchListOnly,
  selectedUniverses: (state) => state.selectedUniverses,
  selectedUniverseIds: (state) => state.selectedUniverses?.map((item) => item.id) || null,
  licenseList: (state) => state.licenseList,
  userGroups: (state) => state?.user?.signInUserSession?.accessToken?.payload?.['cognito:groups'],
  isAdmin: (_, getters) => !!getters.userGroups?.includes('admin'),
  isDataAnalyst: (_, getters) => getters.userGroups?.includes('dataAnalyst'),
  attributes: (state) => state?.user?.attributes,
}
